import moment from "moment";
import { CsvSeparator } from "consts/general";
import { useForm as useFormHook } from "hooks";
import {
    FormField,
    type UploadSettlementForm,
    type UploadSettlement
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = ({
    MOR = null,
    PSP = null,
    settlementDate,
    ...restInitialValues
}: Partial<UploadSettlement>): UploadSettlement => ({
    [FormField.SettlementDate]: moment(settlementDate),
    [FormField.Mor]: MOR,
    [FormField.Psp]: PSP,
    [FormField.CsvSeparator]: CsvSeparator.Comma,
    [FormField.File]: null,
    ...restInitialValues
});

export const useForm = (uploadSettlementForm: UploadSettlementForm) =>
    useFormHook({
        ...uploadSettlementForm,
        isInitialValid: false,
        validateOnMount: false,
        validateOnChange: true,
        validationSchema: useValidationSchema()
    });
